import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useSelector } from "react-redux";

interface Props {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  availableDates: Date[];
  autoOpen?: boolean;
  hideIcon?: boolean;
  // Fire onDateChange even for the highlighted day (leaving a date range).
  allowSameDay?: boolean;
}

const ReusableDatePicker = ({
  selectedDate,
  onDateChange,
  availableDates,
  autoOpen = false,
  hideIcon = false,
  allowSameDay = false,
}: Props) => {
  const { userDetails } = useSelector((s: any) => s.auth.loginDetails);

  const [open, setOpen] = useState(autoOpen);

  useEffect(() => {
    setOpen(autoOpen);
  }, [autoOpen]);

  const fifteenDaysAgo = new Date();
  fifteenDaysAgo.setDate(
    fifteenDaysAgo.getDate() - parseInt(userDetails?.fleet_videos_upto || "15")
  );

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {!hideIcon && (
        <div
          onClick={() => setOpen((p) => !p)}
          style={{ cursor: "pointer", paddingLeft: 5 }}
        >
          <CalendarTodayIcon />
        </div>
      )}

      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: hideIcon ? 0 : 30,
            zIndex: 9999,
          }}
        >
          <DatePicker
            inline
            selected={selectedDate}
            includeDates={availableDates}
            maxDate={new Date()}
            minDate={fifteenDaysAgo}
            allowSameDay={allowSameDay}
            onClickOutside={() => setOpen(false)}
            onChange={(date: any) => {
              onDateChange(date);
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ReusableDatePicker;

// import React, { useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import { useSelector } from 'react-redux';

// const ReusableDatePicker = ({ selectedDate, onDateChange, availableDates }: any) => {
//   const { userDetails } = useSelector((s: any) => s.auth.loginDetails);
//   const [open, setOpen] = useState(false);

//   const fifteenDaysAgo = new Date();
//   fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - parseInt(userDetails?.fleet_videos_upto));

//   const handleIconClick = () => {
//     setOpen((prev) => !prev);
//   };

//   const handleDateChange = (date: any) => {
//     onDateChange(date);
//     setOpen(false);
//   };

//   return (
//     <div style={{ position: 'relative', display: 'inline-block' }}>
//       <div onClick={handleIconClick} style={{ cursor: 'pointer', paddingLeft: "5px" }}>
//         <CalendarTodayIcon style={{ color: 'black' }} />
//       </div>
//       {open && (
//         <div style={{ position: 'absolute', zIndex: 1000, right: '0px' }}>
//           <DatePicker
//             maxDate={new Date()}
//             minDate={fifteenDaysAgo}
//             selected={selectedDate}
//             onChange={handleDateChange}
//             onClickOutside={() => setOpen(false)}
//             inline
//             popperPlacement="bottom"
//             includeDates={availableDates}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReusableDatePicker;

